module.exports = __webpack_public_path__ + "img/avatar5.ffe4f6d4.png";